"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingPlanTypes = {
    noPlan: 0,
    azPlan: 1,
    xPlanPartners: 2,
    xPlanFriends: 3
};
exports.default = exports.PricingPlanTypes;
